import { connect } from 'react-redux';
import { registerPropertyAccount } from '../modules/hotels';

import Register from '../components/Register';

const mapDispatchToProps = {
  registerPropertyAccount,
};

const mapStateToProps = state => ({
  message: state.hotels.register.message,
  registered: state.hotels.register.registered,
  perms: state.auth.perms,
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);



// WEBPACK FOOTER //
// src/routes/hotels/containers/RegisterHotelContainer.js